<app-tools-page-tabs></app-tools-page-tabs>

<!-- <nav class="breadcrumb-sm" aria-label="Breadcrumb">
    <div class="container">
        <ol class="cd-breadcrumb">
			<li><a [routerLink]="['/']">Home</a>
            <span aria-hidden="true" class="breadcrumb-separator">&raquo;</span>
            </li>
			<li class="current" aria-current="page"><em>Grammar Checker</em></li>
		</ol>
    </div>
</nav> -->

<div class="multiTabSection " id="grammarTabs"></div>
<app-gchero-section></app-gchero-section>
<section class="banner-section checker-banner d-none" #target>
    <div class="container">
        <div class="row justify-content-center align-items-center">
            <!-- <div class="col-lg-6">
                <div class="banner-title text-left">
                    <div class="title text-left"><h1>Free Grammar Checker</h1></div>
                    <p class="text-left">Check grammar, spelling, punctuation, word choice, sentence structure, and writing clarity with Trinka's Free Grammar Checker.</p>
                </div>
                <div class="btn-group mt-30">
                    <a 
                        [href]="trinkaCloudUrl + '/guest-mode?redirect=grammer&rg_GB'"
                        class="filled-btn"
                        target="_blank"
                        rel="noopener noreferrer"
                        (click)="trackGrammarCheckerClick()"
                    >
                        Try for Free — No Signup Required
                    </a>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="top-banner-right">
                    
                </div>
            </div> -->
        </div>
        <!-- <div class="row">
            <div class="col-12">
                <div class="multiTabSection">
                    <ul class="nav nav-tabs" role="tablist">
                
                        <li class="nav-item" role="presentation">
                            <button
                                type="button"
                                id="englishTab"
                                class="nav-link"
                                [ngClass]="{ 'active': selectedTab === 'english' }"
                                role="tab"
                                [attr.aria-selected]="selectedTab === 'english'"
                                [attr.tabindex]="selectedTab === 'english' ? '0' : '-1'"
                                aria-controls="EnglishGrammarChecker"
                                (click)="selectTab('english')">
                                English
                            </button>
                        </li>
                
                        <li class="nav-item" role="presentation">
                            <button
                                type="button"
                                id="spanishTab"
                                class="nav-link"
                                [ngClass]="{ 'active': selectedTab === 'spanish' }"
                                role="tab"
                                [attr.aria-selected]="selectedTab === 'spanish'"
                                [attr.tabindex]="selectedTab === 'spanish' ? '0' : '-1'"
                                aria-controls="SpanishGrammarChecker"
                                (click)="selectTab('spanish')">
                                Spanish
                            </button>
                        </li>
                
                    </ul>
                
                    <div class="tab-content">
                
                        <div
                            id="EnglishGrammarChecker"
                            class="tab-pane"
                            role="tabpanel"
                            tabindex="0"
                            aria-labelledby="englishTab"
                            [attr.aria-hidden]="selectedTab !== 'english'"
                            [ngClass]="{
                                'active show': selectedTab === 'english'
                            }">
                
                            <app-english-grammar-checker></app-english-grammar-checker>
                
                        </div>
                
                        <div
                            id="SpanishGrammarChecker"
                            class="tab-pane"
                            role="tabpanel"
                            tabindex="0"
                            aria-labelledby="spanishTab"
                            [attr.aria-hidden]="selectedTab !== 'spanish'"
                            [ngClass]="{
                                'active show': selectedTab === 'spanish'
                            }">
                
                            <app-spanish-grammar-checker></app-spanish-grammar-checker>
                
                        </div>
                
                    </div>
                </div>

            </div>
        </div> -->
    </div>
    <span class="shape-1"></span>
    <span class="shape-2"></span>
    <span class="shape-3"></span>
</section>

<app-global-leaders [title]="'Trinka\'s Grammar Checker - Trusted by Global Leaders'"></app-global-leaders>

<app-gcchecks></app-gcchecks>

<app-gcoffline></app-gcoffline>

<!-- <section class="section-pd list-wrapper-style-2 gcKeyFeatures">
    <div class="trinka_container container">
       <div class="row justify-content-center">
          <div class="col-lg-12 col-md-12">
             <div class="trinka-title text-center mb-0">
                <h2 class="trinka-sub-title mb-2 p-2" style="font-size: 20px;">#1 Grammar Checker</h2>
                <h2>Grammar Checker That Helps You Write Clearly and Confidently</h2>
                <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                <p class="mb-1">Improve the flow of your writing and strengthen your sentences with our AI-powered Grammar Checker Now!</p>
             </div>
          </div>
       </div>
       <div class="row justify-content-center">
          <div class="col-lg-12 col-md-12">
             <div class="row justify-content-center">
                <div class="col-md-6 col-lg-4">
                   <div class="list-wrapper-content-2 list-style-cards bt-none">
                        <div class="media-left">
                            <svg width="40" height="40" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4.5 4.60547L1.95117 12H0.410156L3.62109 3.46875H4.60547L4.5 4.60547ZM6.63281 12L4.07812 4.60547L3.9668 3.46875H4.95703L8.17969 12H6.63281ZM6.50977 8.83594V10.002H1.86914V8.83594H6.50977ZM12.334 8.14453H10.1602L10.1484 7.07227H12.0469C12.3672 7.07227 12.6387 7.02539 12.8613 6.93164C13.0879 6.83398 13.2598 6.69531 13.377 6.51562C13.4941 6.33203 13.5527 6.11133 13.5527 5.85352C13.5527 5.56836 13.498 5.33594 13.3887 5.15625C13.2793 4.97656 13.1113 4.8457 12.8848 4.76367C12.6621 4.68164 12.377 4.64062 12.0293 4.64062H10.6055V12H9.13477V3.46875H12.0293C12.498 3.46875 12.916 3.51367 13.2832 3.60352C13.6543 3.69336 13.9688 3.83398 14.2266 4.02539C14.4883 4.21289 14.6855 4.45117 14.8184 4.74023C14.9551 5.0293 15.0234 5.37305 15.0234 5.77148C15.0234 6.12305 14.9395 6.44531 14.7715 6.73828C14.6035 7.02734 14.3555 7.26367 14.0273 7.44727C13.6992 7.63086 13.291 7.74023 12.8027 7.77539L12.334 8.14453ZM12.2695 12H9.69727L10.3594 10.834H12.2695C12.6016 10.834 12.8789 10.7793 13.1016 10.6699C13.3242 10.5566 13.4902 10.4023 13.5996 10.207C13.7129 10.0078 13.7695 9.77539 13.7695 9.50977C13.7695 9.23242 13.7207 8.99219 13.623 8.78906C13.5254 8.58203 13.3711 8.42383 13.1602 8.31445C12.9492 8.20117 12.6738 8.14453 12.334 8.14453H10.6816L10.6934 7.07227H12.8438L13.1777 7.47656C13.6465 7.49219 14.0312 7.5957 14.332 7.78711C14.6367 7.97852 14.8633 8.22656 15.0117 8.53125C15.1602 8.83594 15.2344 9.16406 15.2344 9.51562C15.2344 10.0586 15.1152 10.5137 14.877 10.8809C14.6426 11.248 14.3047 11.5273 13.8633 11.7188C13.4219 11.9062 12.8906 12 12.2695 12ZM21.7559 9.22266H23.2207C23.1738 9.78125 23.0176 10.2793 22.752 10.7168C22.4863 11.1504 22.1133 11.4922 21.6328 11.7422C21.1523 11.9922 20.5684 12.1172 19.8809 12.1172C19.3535 12.1172 18.8789 12.0234 18.457 11.8359C18.0352 11.6445 17.6738 11.375 17.373 11.0273C17.0723 10.6758 16.8418 10.252 16.6816 9.75586C16.5254 9.25977 16.4473 8.70508 16.4473 8.0918V7.38281C16.4473 6.76953 16.5273 6.21484 16.6875 5.71875C16.8516 5.22266 17.0859 4.79883 17.3906 4.44727C17.6953 4.0918 18.0605 3.82031 18.4863 3.63281C18.916 3.44531 19.3984 3.35156 19.9336 3.35156C20.6133 3.35156 21.1875 3.47656 21.6562 3.72656C22.125 3.97656 22.4883 4.32227 22.7461 4.76367C23.0078 5.20508 23.168 5.71094 23.2266 6.28125H21.7617C21.7227 5.91406 21.6367 5.59961 21.5039 5.33789C21.375 5.07617 21.1836 4.87695 20.9297 4.74023C20.6758 4.59961 20.3438 4.5293 19.9336 4.5293C19.5977 4.5293 19.3047 4.5918 19.0547 4.7168C18.8047 4.8418 18.5957 5.02539 18.4277 5.26758C18.2598 5.50977 18.1328 5.80859 18.0469 6.16406C17.9648 6.51562 17.9238 6.91797 17.9238 7.37109V8.0918C17.9238 8.52148 17.9609 8.91211 18.0352 9.26367C18.1133 9.61133 18.2305 9.91016 18.3867 10.1602C18.5469 10.4102 18.75 10.6035 18.9961 10.7402C19.2422 10.877 19.5371 10.9453 19.8809 10.9453C20.2988 10.9453 20.6367 10.8789 20.8945 10.7461C21.1562 10.6133 21.3535 10.4199 21.4863 10.166C21.623 9.9082 21.7129 9.59375 21.7559 9.22266Z" fill="#7A28A0"/>
                                <path d="M10.4004 18.5844L13.0658 21.5996L18.8004 15.5996" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                        <div class="media-body">
                            <h3>Advanced Grammar Check</h3>
                            <p>Fix multiple complex grammar issues, sentence structure, tone and styles. </p>
                        </div>
                   </div>
                </div>
                <div class="col-md-6 col-lg-4">
                   <div class="list-wrapper-content-2 list-style-cards">
                        <div class="media-left">
                            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 25" fill="none">
                                <path d="M12 5H3" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M12 10H3" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M21 15H3" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M21 20H3" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                        <div class="media-body">
                            <h3>Sentence Structure</h3>
                            <p>Make your sentences easy to read with our grammar checker.</p>
                        </div>
                   </div>
                </div>
                <div class="col-md-6 col-lg-4">
                   <div class="list-wrapper-content-2 list-style-cards">
                        <div class="media-left">
                            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 25" fill="none">
                                <path d="M15 14.25H7C6.59 14.25 6.25 13.91 6.25 13.5C6.25 13.09 6.59 12.75 7 12.75H15C15.41 12.75 15.75 13.09 15.75 13.5C15.75 13.91 15.41 14.25 15 14.25Z" fill="#7A28A0"/>
                                <path d="M16.029 10.5803H7.0882C6.62998 10.5803 6.25 10.2403 6.25 9.83032C6.25 9.42032 6.62998 9.08032 7.0882 9.08032H16.029C16.4872 9.08032 16.8672 9.42032 16.8672 9.83032C16.8672 10.2403 16.4872 10.5803 16.029 10.5803Z" fill="#7A28A0"/>
                                <path d="M12 18.25H7C6.59 18.25 6.25 17.91 6.25 17.5C6.25 17.09 6.59 16.75 7 16.75H12C12.41 16.75 12.75 17.09 12.75 17.5C12.75 17.91 12.41 18.25 12 18.25Z" fill="#7A28A0"/>
                                <path d="M15 23.25H9C3.38 23.25 2.25 20.6 2.25 16.32V10.15C2.25 5.41 3.85 3.48 7.96 3.25H16C16.01 3.25 16.03 3.25 16.04 3.25C20.15 3.48 21.75 5.41 21.75 10.15V16.32C21.75 20.6 20.62 23.25 15 23.25ZM8 4.75C5.2 4.91 3.75 5.79 3.75 10.15V16.32C3.75 20.15 4.48 21.75 9 21.75H15C19.52 21.75 20.25 20.15 20.25 16.32V10.15C20.25 5.8 18.81 4.91 15.98 4.75H8Z" fill="#7A28A0"/>
                            </svg>
                        </div>
                        <div class="media-body">
                            <h3>Word<br class="d-lg-block d-none"/> Choice</h3>
                            <p>Use the words that suits best as per your context and fits well in your document. </p>
                        </div>
                   </div>
                </div>
                <div class="col-md-6 col-lg-4">
                   <div class="list-wrapper-content-2 list-style-cards bt-1">
                        <div class="media-left">
                            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 25" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M19.928 1.27032C19.3169 1.47798 17.1419 2.21843 15.0947 2.91565L11.3725 4.18343L7.23548 2.71954L3.09837 1.25554L3.06881 4.09998L3.03915 6.94443L1.76137 7.38887L0.483592 7.83332L0.455147 16.031C0.428592 23.6418 0.499864 24.2778 0.499864 24.2778C0.499864 24.2778 3.11648 23.6045 6.4207 22.5075L12.0391 20.6423L17.3169 22.3242C20.2197 23.2493 22.8071 24.0768 23.0669 24.163L23.5391 24.3199V16.2308V8.14176L22.4836 7.82465L21.428 7.50754V4.33154C21.428 1.28265 21.428 0.722229 21.428 0.722229C21.428 0.722229 20.5391 1.06265 19.928 1.27032ZM20.8888 4.44445C20.8888 6.59167 20.8888 7.33334 20.8888 7.33334C20.8888 7.33334 12.4043 4.65354 12.295 4.56376C12.2106 4.4942 20.8888 1.50001 20.8888 1.50001C20.8888 1.50001 20.8888 1.8889 20.8888 4.44445ZM11.5391 12.4908V20.2036L6.3447 21.9352C3.4877 22.8875 1.05542 23.6667 1.05542 23.6667C1.05542 23.6667 0.983592 20.1958 0.983592 15.9536V8.24076L6.12248 6.51798C8.94893 5.57054 11.3239 4.79132 11.4003 4.78654C11.5101 4.77954 11.5391 6.38976 11.5391 12.4908Z" fill="#7A28A0"/>
                                <path d="M5.60512 11.9638C5.8266 11.9016 6.04846 11.839 6.27068 11.7761C6.28327 12.9168 6.29586 14.0583 6.30846 15.2005C6.3129 15.565 6.24401 15.9072 6.09957 16.2261C5.95623 16.5427 5.7529 16.8161 5.48846 17.045C5.22512 17.2727 4.91401 17.4316 4.55734 17.5238C4.20179 17.615 3.88957 17.615 3.6229 17.525C3.35734 17.4338 3.15068 17.2694 3.00401 17.0316C2.85734 16.7927 2.78401 16.4938 2.7829 16.135C2.78142 15.0098 2.77957 13.885 2.77734 12.7605C2.99883 12.6983 3.22031 12.6361 3.44179 12.5738C3.44623 13.6812 3.44994 14.7879 3.4529 15.8938C3.4529 16.1261 3.49734 16.3227 3.58623 16.4794C3.67734 16.6372 3.80401 16.7461 3.96845 16.8083C4.1329 16.8672 4.32734 16.8694 4.55179 16.8105C4.77846 16.7527 4.9729 16.6494 5.13512 16.505C5.29957 16.3561 5.42401 16.1805 5.50957 15.975C5.59623 15.7705 5.63845 15.5494 5.63623 15.315C5.62586 14.1979 5.61549 13.0809 5.60512 11.9638Z" fill="#7A28A0"/>
                                <path d="M6.87845 16.8416C6.85623 15.1024 6.83401 13.3631 6.81179 11.6238C7.03253 11.5616 7.25327 11.499 7.47401 11.4361C7.48586 12.2694 7.49808 13.1024 7.51068 13.935C7.52846 13.9298 7.5466 13.925 7.56512 13.9205C8.16883 12.9175 8.77105 11.9112 9.37179 10.9016C9.65031 10.8231 9.92882 10.745 10.2073 10.6672C9.63105 11.6242 9.05327 12.5787 8.47401 13.5305C9.09031 14.3364 9.70846 15.145 10.3285 15.9561C10.0588 16.0257 9.78883 16.0953 9.51846 16.165C9.02512 15.5057 8.53253 14.8479 8.04068 14.1916C7.86957 14.4753 7.69845 14.7587 7.52734 15.0416C7.53475 15.5846 7.54253 16.1272 7.55068 16.6694C7.32623 16.7272 7.10216 16.7846 6.87845 16.8416Z" fill="#7A28A0"/>
                                <path d="M16.4898 11.4536C16.7205 11.515 16.9511 11.5768 17.1817 11.639C17.1878 12.7796 17.194 13.9206 17.2001 15.0619C17.2011 15.4253 17.1285 15.729 16.978 15.9708C16.8286 16.2106 16.6168 16.3761 16.3445 16.4651C16.0713 16.5541 15.7509 16.5509 15.3825 16.4556C15.0161 16.3604 14.6948 16.1981 14.4205 15.9666C14.1472 15.7342 13.9344 15.4578 13.7829 15.1373C13.6325 14.8159 13.5567 14.4714 13.5567 14.1059C13.5561 12.9597 13.5554 11.8135 13.5547 10.6672C13.7839 10.7287 14.0135 10.7901 14.2434 10.8515C14.2448 11.9761 14.2462 13.1 14.2475 14.2232C14.2486 14.4599 14.2936 14.6818 14.3847 14.8892C14.4788 15.0965 14.6088 15.2756 14.7787 15.4253C14.9476 15.5729 15.1481 15.6776 15.3805 15.7373C15.6138 15.7981 15.8144 15.7981 15.9822 15.7384C16.1531 15.6776 16.2821 15.5677 16.3711 15.4075C16.4622 15.2494 16.5062 15.0515 16.5052 14.8159C16.5004 13.6955 16.4953 12.5747 16.4898 11.4536Z" fill="white"/>
                                <path d="M20.2468 13.818C20.2212 13.5719 20.1209 13.3614 19.947 13.1834C19.773 13.0033 19.555 12.8798 19.293 12.8096C19.1057 12.7604 18.945 12.7499 18.8079 12.7813C18.6718 12.8107 18.5653 12.8735 18.4906 12.9698C18.4169 13.0651 18.3811 13.1866 18.3821 13.3342C18.3832 13.4567 18.4088 13.5698 18.4599 13.6724C18.5131 13.7761 18.5807 13.8682 18.6646 13.952C18.7506 14.0337 18.8417 14.107 18.9389 14.173C19.0361 14.2379 19.1292 14.2944 19.2183 14.3436C19.3684 14.4267 19.5181 14.5101 19.6676 14.5939C19.8139 14.6724 19.9633 14.7667 20.1179 14.8766C20.2724 14.9866 20.4157 15.1154 20.5477 15.263C20.6807 15.4106 20.7882 15.5782 20.8701 15.7667C20.954 15.9551 20.997 16.1646 20.999 16.3981C21.0021 16.6912 20.9386 16.9342 20.8056 17.1268C20.6746 17.3195 20.4832 17.4483 20.2294 17.5143C19.9787 17.5813 19.6727 17.5677 19.3135 17.4745C18.9686 17.3855 18.6708 17.2462 18.419 17.0567C18.1662 16.8682 17.9687 16.6431 17.8254 16.3782C17.6821 16.1132 17.6013 15.8211 17.5849 15.5049C17.8162 15.5656 18.0478 15.626 18.2798 15.686C18.2952 15.8776 18.3494 16.0483 18.4446 16.197C18.5408 16.3457 18.6636 16.4703 18.812 16.5687C18.9614 16.6672 19.1251 16.7394 19.3042 16.7865C19.4997 16.8368 19.6727 16.8473 19.8252 16.8179C19.9777 16.7865 20.0984 16.7206 20.1854 16.619C20.2724 16.5153 20.3154 16.3803 20.3144 16.2117C20.3123 16.0577 20.2724 15.9216 20.1936 15.8033C20.1168 15.686 20.0125 15.5771 19.8804 15.4787C19.7505 15.3813 19.6021 15.285 19.4383 15.1928C19.2568 15.0895 19.076 14.9866 18.8959 14.8839C18.5275 14.6735 18.2358 14.4295 18.0188 14.1531C17.8039 13.8777 17.6965 13.5573 17.6944 13.197C17.6924 12.8965 17.762 12.6536 17.9042 12.4683C18.0454 12.284 18.2368 12.1615 18.4804 12.1039C18.7229 12.0431 18.9972 12.0547 19.3032 12.1363C19.6133 12.2191 19.8866 12.3541 20.124 12.5416C20.3635 12.7279 20.5518 12.9478 20.69 13.1991C20.8302 13.4494 20.9038 13.7154 20.912 13.9939C20.6903 13.9353 20.4686 13.8766 20.2468 13.818Z" fill="white"/>
                            </svg>
                        </div>
                        <div class="media-body">
                            <h3>English & Spanish</h3>
                            <p>Check for English and Spanish texts for grammatical mistakes.</p>
                        </div>
                   </div>
                </div>
                <div class="col-md-6 col-lg-4">
                   <div class="list-wrapper-content-2 list-style-cards bt-1">
                        <div class="media-left">
                            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 25" fill="none">
                                <path d="M3.75 4.43945C3.55109 4.43945 3.36032 4.51847 3.21967 4.65912C3.07902 4.79978 3 4.99054 3 5.18945C3 5.38837 3.07902 5.57913 3.21967 5.71978C3.36032 5.86044 3.55109 5.93945 3.75 5.93945H20.25C20.4489 5.93945 20.6397 5.86044 20.7803 5.71978C20.921 5.57913 21 5.38837 21 5.18945C21 4.99054 20.921 4.79978 20.7803 4.65912C20.6397 4.51847 20.4489 4.43945 20.25 4.43945H3.75ZM6.66 18.592L7.314 17.9395H3.75C3.55109 17.9395 3.36032 18.0185 3.21967 18.1591C3.07902 18.2998 3 18.4905 3 18.6895C3 18.8884 3.07902 19.0791 3.21967 19.2198C3.36032 19.3604 3.55109 19.4395 3.75 19.4395H6.126C6.234 19.1305 6.4125 18.8395 6.66 18.592ZM10.4595 14.797C10.1522 14.6813 9.87391 14.4999 9.64408 14.2654C9.41426 14.0309 9.23846 13.749 9.129 13.4395H3.75C3.55109 13.4395 3.36032 13.5185 3.21967 13.6591C3.07902 13.7998 3 13.9905 3 14.1895C3 14.3884 3.07902 14.5791 3.21967 14.7198C3.36032 14.8604 3.55109 14.9395 3.75 14.9395H10.317L10.4595 14.797ZM11.112 10.4395L11.52 10.3885C11.6829 10.3251 11.8185 10.2069 11.9035 10.0542C11.9885 9.90146 12.0175 9.72387 11.9855 9.55206C11.9535 9.38026 11.8625 9.22503 11.7282 9.11318C11.5939 9.00133 11.4248 8.93988 11.25 8.93945H3.75C3.55109 8.93945 3.36032 9.01847 3.21967 9.15912C3.07902 9.29978 3 9.49054 3 9.68945C3 9.88837 3.07902 10.0791 3.21967 10.2198C3.36032 10.3604 3.55109 10.4395 3.75 10.4395H11.112ZM15.75 7.43945C15.933 7.43955 16.1096 7.50655 16.2467 7.62784C16.3837 7.74912 16.4717 7.91632 16.494 8.09795L16.629 9.19895C16.711 9.86289 17.0125 10.4804 17.4857 10.9533C17.9589 11.4262 18.5765 11.7274 19.2405 11.809L20.3415 11.944C20.5238 11.9656 20.6918 12.0534 20.8137 12.1907C20.9356 12.3279 21.0029 12.5051 21.0029 12.6887C21.0029 12.8723 20.9356 13.0495 20.8137 13.1867C20.6918 13.324 20.5238 13.4118 20.3415 13.4335L19.2405 13.5685C18.5766 13.6504 17.9591 13.952 17.4862 14.4251C17.0133 14.8983 16.7121 15.516 16.6305 16.18L16.4955 17.281C16.4738 17.4632 16.386 17.6312 16.2488 17.7531C16.1115 17.875 15.9343 17.9424 15.7507 17.9424C15.5672 17.9424 15.39 17.875 15.2527 17.7531C15.1155 17.6312 15.0277 17.4632 15.006 17.281L14.871 16.18C14.789 15.516 14.4875 14.8985 14.0143 14.4256C13.5411 13.9527 12.9235 13.6515 12.2595 13.57L11.1585 13.435C10.9762 13.4133 10.8082 13.3255 10.6863 13.1882C10.5644 13.051 10.4971 12.8738 10.4971 12.6902C10.4971 12.5066 10.5644 12.3294 10.6863 12.1922C10.8082 12.0549 10.9762 11.9671 11.1585 11.9455L12.2595 11.8105C12.9234 11.7285 13.5409 11.4269 14.0138 10.9538C14.4867 10.4806 14.7879 9.86294 14.8695 9.19895L15.0045 8.09795C15.0269 7.91607 15.115 7.74866 15.2524 7.62734C15.3897 7.50602 15.5667 7.43918 15.75 7.43945ZM15.75 11.1505C15.3705 11.7805 14.841 12.31 14.211 12.6895C14.841 13.069 15.3705 13.5985 15.75 14.2285C16.1295 13.5985 16.659 13.069 17.289 12.6895C16.6581 12.3098 16.1297 11.7814 15.75 11.1505ZM13.281 15.16C13.4216 15.3006 13.5006 15.4913 13.5006 15.6902C13.5006 15.8891 13.4216 16.0798 13.281 16.2205L8.781 20.7145C8.71181 20.7861 8.62906 20.8432 8.53755 20.8825C8.44605 20.9218 8.34764 20.9425 8.24805 20.9434C8.14847 20.9443 8.04971 20.9253 7.95753 20.8876C7.86536 20.8499 7.78162 20.7942 7.7112 20.7237C7.64078 20.6533 7.58509 20.5696 7.54738 20.4774C7.50967 20.3852 7.4907 20.2865 7.49156 20.1869C7.49243 20.0873 7.51312 19.9889 7.55242 19.8974C7.59173 19.8059 7.64887 19.7231 7.7205 19.654L12.2205 15.1585C12.3611 15.0178 12.5519 14.9389 12.7507 14.9389C12.9496 14.9389 13.1404 15.0178 13.281 15.1585V15.16Z" fill="#7A28A0"/>
                            </svg>
                        </div>
                        <div class="media-body">
                            <h3>Usage &<br class="d-lg-block d-none"/>Style</h3>
                            <p>Polish your phrasing and tone with our AI grammar checker.</p>
                        </div>
                   </div>
                </div>
                <div class="col-md-6 col-lg-4">
                   <div class="list-wrapper-content-2 list-style-cards bt-1">
                        <div class="media-left">
                            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 25" fill="none">
                                <g clip-path="url(#clip0_1083_3335)">
                                    <path d="M14.68 23.25H8C4.35 23.25 2.25 21.15 2.25 17.5V9C2.25 5.35 4.35 3.25 8 3.25H16C19.65 3.25 21.75 5.35 21.75 9V14.13C21.75 14.42 21.58 14.68 21.33 14.81C21.07 14.93 20.76 14.9 20.54 14.72C18.96 13.46 16.53 13.46 14.95 14.75C13.87 15.6 13.26 16.87 13.26 18.26C13.26 19.08 13.48 19.88 13.91 20.57C14.24 21.11 14.65 21.56 15.13 21.9C15.39 22.09 15.51 22.43 15.41 22.74C15.29 23.04 15.01 23.25 14.68 23.25ZM8 4.75C5.14 4.75 3.75 6.14 3.75 9V17.5C3.75 20.36 5.14 21.75 8 21.75H12.89C12.79 21.62 12.7 21.48 12.62 21.34C12.05 20.42 11.75 19.35 11.75 18.25C11.75 16.4 12.57 14.7 14.01 13.57C15.72 12.18 18.25 11.88 20.25 12.8V9C20.25 6.14 18.86 4.75 16 4.75H8Z" fill="#7A28A0"/>
                                    <path d="M13 12.25H7C6.59 12.25 6.25 11.91 6.25 11.5C6.25 11.09 6.59 10.75 7 10.75H13C13.41 10.75 13.75 11.09 13.75 11.5C13.75 11.91 13.41 12.25 13 12.25Z" fill="#7A28A0"/>
                                    <path d="M9.62 17.25H7C6.59 17.25 6.25 16.91 6.25 16.5C6.25 16.09 6.59 15.75 7 15.75H9.62C10.03 15.75 10.37 16.09 10.37 16.5C10.37 16.91 10.04 17.25 9.62 17.25Z" fill="#7A28A0"/>
                                    <path d="M17.75 24.25C16.47 24.25 15.26 23.85 14.24 23.11C13.6 22.65 13.05 22.05 12.62 21.34C12.05 20.42 11.75 19.35 11.75 18.25C11.75 16.4 12.57 14.7 14.01 13.57C16.09 11.88 19.37 11.87 21.47 13.54C22.92 14.68 23.75 16.4 23.75 18.25C23.75 19.35 23.45 20.42 22.88 21.34C22.56 21.89 22.15 22.37 21.68 22.76C20.61 23.72 19.21 24.25 17.75 24.25ZM17.75 13.75C16.73 13.75 15.73 14.1 14.94 14.74C13.86 15.59 13.25 16.86 13.25 18.25C13.25 19.07 13.47 19.87 13.9 20.56C14.23 21.1 14.64 21.55 15.12 21.89C15.89 22.45 16.8 22.75 17.75 22.75C18.86 22.75 19.88 22.36 20.7 21.63C21.06 21.33 21.35 20.98 21.59 20.57C22.02 19.87 22.25 19.07 22.25 18.25C22.25 16.86 21.63 15.5799 20.54 14.7199C19.74 14.0799 18.78 13.75 17.75 13.75Z" fill="#7A28A0"/>
                                    <path d="M17.75 21.5C17.34 21.5 17 21.16 17 20.75C17 19.79 16.21 19 15.25 19C14.84 19 14.5 18.66 14.5 18.25C14.5 17.84 14.84 17.5 15.25 17.5C16.21 17.5 17 16.71 17 15.75C17 15.34 17.34 15 17.75 15C18.16 15 18.5 15.34 18.5 15.75C18.5 16.71 19.29 17.5 20.25 17.5C20.66 17.5 21 17.84 21 18.25C21 18.66 20.66 19 20.25 19C19.29 19 18.5 19.79 18.5 20.75C18.5 21.16 18.16 21.5 17.75 21.5ZM17.32 18.25C17.47 18.38 17.62 18.52 17.75 18.68C17.88 18.53 18.02 18.38 18.18 18.25C18.03 18.12 17.88 17.98 17.75 17.82C17.62 17.98 17.48 18.12 17.32 18.25Z" fill="#7A28A0"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_1083_3335">
                                    <rect width="24" height="24" fill="white" transform="translate(0 0.5)"/>
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                        <div class="media-body">
                            <h3>Advanced Spelling Check</h3>
                            <p class="pb-0">Use the right spelling for your subject matter with our Spell Checker Now!</p>
                        </div>
                   </div>
                </div>
             </div>
          </div>
       </div>
    </div>
</section> -->


<!-- <section class="section-pd trinka-banner">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-lg-12 col-md-12">
                <div class="trinka-title text-white text-center">
                    <h2 class="text-white">How to Use Trinka’s Grammar Checker?</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <ul class="row justify-content-center list-unstyled match-box">
            <li class="col-lg-3 col-md-6 col-sm-6 col-12 dflex">
                <div class="tool-intro-section c-card">
                    <div class="tool-content">
                        <small>1</small>
                        <h3>Type or Paste the Text</h3>
                        <p>You can either type directly into the editor or copy and paste your text.</p>
                    </div>
                </div>
            </li>
        
            <li class="col-lg-3 col-md-6 col-sm-6 col-12 dflex">
                <div class="tool-intro-section c-card">
                    <div class="tool-content">
                        <small>2</small>
                        <h3>Click "Check Grammar"</h3>
                        <p>Our grammar checker tool will examine your text for grammatical mistakes.</p>
                    </div>
                </div>
            </li>
        
            <li class="col-lg-3 col-md-6 col-sm-6 col-12 dflex">
                <div class="tool-intro-section c-card">
                    <div class="tool-content">
                        <small>3</small>
                        <h3>Review Suggestions</h3>
                        <p>Check the recommended suggestions, and click to accept the solution. It’s that easy!</p>
                    </div>
                </div>
            </li>
        
            <li class="col-lg-3 col-md-6 col-sm-6 col-12 dflex">
                <div class="tool-intro-section c-card">
                    <div class="tool-content">
                        <small>4</small>
                        <h3>Copy & Use the Revised Text</h3>
                        <p>Post review, get the revised results and copy the text. It’s that easy!</p>
                    </div>
                </div>
            </li>
        </ul>
        <div class="row justify-content-center">
            <div class="col-12">
                <div class="btn-group  mt-30 justify-content-center">
                    <a [href]="trinkaCloudUrl + '/guest-mode?redirect=grammer&rg_GB'" class="white-btn" target="_blank" (click)="trackGrammarCheckerClick()">Try Grammar Checker Now - it's free!</a>
                </div>
            </div>
        </div>
    </div>
</section> -->

<section class="section-pd bg-light-purple">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-lg-12 col-md-12">
                <div class="trinka-title text-center mb-0">
                    <h2>Why to Use Trinka’s Grammar Checker?</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
            <div class="col-md-6 col-md-6">
                <div class="trinka-title mb-0 mt-30">
                    <p>Improve your writing with Trinka’s free Grammar Checker and avoid common mistakes with:</p>
                    <ul class="bt-list">
                        <li>Grammar & Spell Checker </li>
                        <li><a [routerLink]="['/punctuation-checker']" class="text-link">Punctuation</a> & Word Choice </li>
                        <li>Sentence Structure & run-on phrases </li>
                
                        <li>And more – <span class="text-link" (click)="scroll(target)">try it yourself now!</span></li>
                    </ul>
                </div>
            </div>
            <div class="col-md-6 col-md-6">
                <div class="mt-30 text-center">
                    <img src="assets/images/features/features-page/grammar-checker.png" width="648" height="533" alt="Grammar Checker Uses" class="img-fluid">
                </div>
            </div>
        </div>
    </div>
</section>


<section class="section-pd-xs trinka-banner">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-6 col-lg-3 col-sm-6 col-6">
                <div class="counter">
                    <span>
                        <svg width="40" height="40" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14.707 12L6 3.293C5.8094 3.11142 5.55625 3.01014 5.293 3.01014C5.02975 3.01014 4.7766 3.11142 4.586 3.293L3.293 4.586C3.10553 4.77353 3.00021 5.02784 3.00021 5.293C3.00021 5.55816 3.10553 5.81247 3.293 6L11.9995 14.707C12.187 14.8945 12.4413 14.9998 12.7065 14.9998C12.9717 14.9998 13.226 14.8945 13.4135 14.707L14.707 13.414C14.8945 13.2265 14.9998 12.9722 14.9998 12.707C14.9998 12.4418 14.8945 12.1875 14.707 12ZM4 5.293L5.293 4L7.793 6.5L6.4995 7.7935L4 5.293ZM12.7065 14L7.2065 8.5005L8.5 7.207L14 12.707L12.7065 14ZM1 8L2 7L3 8L2 9L1 8ZM7 2L8 1L9 2L8 3L7 2ZM1 2L2 1L3 2L2 3L1 2Z" fill="#fff"/>
                        </svg> 
                    </span>
                    <p>AI-Powered</p>
                    <small>Create precise content with AI</small>
                </div>
            </div>
            <div class="col-md-6 col-lg-3 col-sm-6 col-6">
                <div class="counter">
                    <span>
                        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5 8L11 14M4 14L10 8L12 5M2 5H14M7 2H8M22 22L17 12L12 22M14 18H20" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </span>
                    <p>Multilingual</p>
                    <small>Correct grammar in English & Spanish</small>
                </div>
            </div>
            <div class="col-md-6 col-lg-3 col-sm-6 col-6">
                <div class="counter pt-lg-0 pt-3">
                    <span>
                        <svg width="40" height="40" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.5 8.50003L4.5 0.5L8.5 8.50003M1.8333 5.83333H7.1667M7.1667 11.1666L8.5 12.5L11.1667 9.83333" stroke="#fff" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </span>
                    <p>Advanced</p>
                    <small>Correct grammar, punctuation, and more</small>
                </div>
            </div>
            <div class="col-md-6 col-lg-3 col-sm-6 col-6">
                <div class="counter pt-lg-0 pt-3">
                    <span>
                        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9 3H17C17.5304 3 18.0391 3.21071 18.4142 3.58579C18.7893 3.96086 19 4.46957 19 5V19C19 19.5304 18.7893 20.0391 18.4142 20.4142C18.0391 20.7893 17.5304 21 17 21H9M15 12L11 8M15 12L11 16M15 12H5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </span>
                    <p>No Sign Ups</p>
                    <small>Start instantly — no sign-up needed <span>T&C Apply</span></small>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd list-wrapper-style-2">
    <div class="trinka_container container">
        <!-- <div class="row justify-content-center">
            <div class="col-md-12 col-lg-12">
                <div class="trinka-title mb-0 text-center">
                    <h2>Why Users Love Our Grammar Checker?</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div> -->
        <div class="row">
            <div class="col-lg-6 col-md-6">
                <div class="trinka-title mb-0">
                    <h2>Why Users Love Our Grammar Checker?</h2>
                    <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                </div>
                <div class="list-wrapper-content-2 list-style-cards bt-none pt-2">
                    <!-- <h3>Catches <br class="d-lg-block d-none"/>Errors </h3> -->
                    <ul class="bt-list">
                        <li>Grammar Check for 3,000+ grammar errors</li>
                        <li>Spelling &amp; Sentence Checks</li>
                        <li>Professional Writing</li>
                        <li>Your Work Stays Private (<a [routerLink]="['/enterprise/confidential-data-plan-for-grammar-checker']" class="text-link">Confidential Data Plan</a> for enhanced protection)</li>
                
                    </ul>
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <video class="vid-video w-100" id="myVideo" playsinline autoplay loop muted oncanplay="this.play()" onloadedmetadata="this.muted = true" >
                    <source src="assets/images/features/grammar-checker/Bubble-view.mp4" type="video/mp4">
                    Your browser does not support the video element. Kindly update it to latest version.
                </video>
            </div>
            <!-- <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards">
                    <h3>Professional Writing </h3>
                    <ul class="bt-list">
                        <li>Detecting and correcting inconsistencies</li>
                        <li>Handles UK/US spelling variations</li>
                        <li>Supports APA, AMA, AGU, ACS, and IEEE styles for a polished result</li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards">
                    <h3>Your Work Stays Private</h3>
                    <ul class="bt-list">
                        <li>Ensures privacy of your unpublished research</li>
                        <li>Data is not stored or used for AI training</li>
                        <li>Confidential Data Plan for enhanced protection of sensitive work</li>
                    </ul>
                </div>
            </div> -->
            <!-- <div class="col-12">
                <div class="btn-group justify-content-center mt-3">
                    <a href="https://cloud.trinka.ai/signup?_rg=GB" target="_blank" rel="noopener noreferrer" class="filled-btn">Sign Up for Free</a>
                </div>
            </div> -->
        </div>
    </div>
</section>



<section class="trinka-banner section-pd-sm">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-12">
                <ul class="listAvailableOn">
                    <li>
                        <b>Available in:</b>
                    </li>
                    <li>
                        <a href="/grammar-checker" target="_blank">
                            <img src="assets/images/flags/united-states-of-america.png" width="32" height="32" alt="usa" />
                            <span>US - Grammar Checker</span>                        
                        </a>
                    </li>
                    <li>
                        <a href="https://www.trinka.ai/jp/grammar-checker" target="_blank">
                            <img src="assets/images/flags/japan.png" width="32" height="32" alt="japan" />
                            <span>Japan - 文法チェッカー 
                            </span>                        
                        </a>
                    </li>
                    <li>
                        <a href="https://www.trinka.ai/es/corrector-gramatical" target="_blank">
                            <img src="assets/images/flags/spain.png" width="32" height="32" alt="spain" />
                            <span>Spanish - corrector gramatical 
                            </span>                        
                        </a>
                    </li>
                    <li>
                        <a href="https://www.trinka.ai/tw/grammar-checker" target="_blank">
                            <img src="assets/images/flags/taiwan.png" width="32" height="32" alt="taiwan" />
                            <span>Taiwan - 語法檢查器
                            </span>                        
                        </a>
                    </li>
                    <li>
                        <a href="https://www.trinka.ai/kr/grammar-checker" target="_blank">
                            <img src="assets/images/flags/south-korea.png" width="32" height="32" alt="south-korea" />
                            <span>South Korea: 문법 검사기/  
                            </span>                        
                        </a>
                    </li>
                    <li>
                        <a href="https://www.trinka.ai/pt/grammar-checker" target="_blank">
                            <img src="assets/images/flags/portugal.png" width="32" height="32" alt="portugal" />
                            <span>Portugal: verificador gramatical  
                            </span>                        
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</section>


<section class="section-pd bg-light">
    <div class="trinka_container container">
        <div class="row align-items-center justify-content-center">
            <div class="col-lg-9 col-md-12">
                <div class="trinka-title text-center mb-0">
                    <h2>Grammar Checker Examples: Before and After</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p class="w-100">Even experienced writers make grammar mistakes. See how our grammar checker helps improve clarity, correctness, and readability.</p>
                </div>
            </div>
            <div class="col-lg-12 col-md-12">
                <div class="error-comparison-table">
                    <table>
                        <thead>
                          <tr>
                            <th>Error Type</th>
                            <th>Before</th>
                            <th>After</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Subject-Verb Agreement</td>
                            <td>The results shows improvement.</td>
                            <td>The results show improvement.</td>
                          </tr>
                          <tr>
                            <td>Verb Tense</td>
                            <td>Researchers collect data last year.</td>
                            <td>Researchers collected data last year.</td>
                          </tr>
                          <tr>
                            <td>Article Usage</td>
                            <td>Study provides detailed analysis.</td>
                            <td>The study provides detailed analysis.</td>
                          </tr>
                          <tr>
                            <td>Preposition</td>
                            <td>Participants were divided on groups.</td>
                            <td>Participants were divided into groups.</td>
                          </tr>
                          <tr>
                            <td>Word Choice</td>
                            <td>The experiment had an affect.</td>
                            <td>The experiment had an effect.</td>
                          </tr>
                          <tr>
                            <td>Passive Voice</td>
                            <td>The report was completed by the team.</td>
                            <td>The team completed the report.</td>
                          </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-purple section-pd">
    <div class="trinka_container">
        <div class="row match-box justify-content-center">
            <div class="col-12">
                <div class="trinka-title mb-0 text-center">
                    <h2>Why Writers Choose Our Grammar Checker</h2>
                </div>
            </div>
            <div class="col-md-10 col-lg-10">
                <div class="review-snippet mt-40">
                    <div class="snippet-slider">
                        <span class="quotes">
                            <img src="../../../assets/images/double_quotes_icon.png" width="46" height="32" alt="" aria-hidden="true" />
                        </span>
                        <div id="snippetSlider"
                            class="carousel slide"
                            data-ride="carousel"
                            role="region"
                            aria-roledescription="carousel"
                            aria-label="Testimonials carousel"
                        >
                            <!-- <ol class="carousel-indicators">
                                <li *ngFor="let testimonial of testimonials; let i = index" [attr.data-target]="'#snippetSlider'" [attr.data-slide-to]="i" [class.active]="i === 0"></li>
                            </ol> -->
                            <div class="carousel-inner">
                                <div *ngFor="let testimonial of testimonials; let i = index"
                                    class="carousel-item"
                                    [class.active]="i === 0"
                                    [id]="'testimonial-' + i"
                                    role="group"
                                    [attr.aria-label]="'Testimonial ' + (i + 1) + ' of ' + testimonials.length"
                                    [attr.aria-hidden]="i !== activeSlide"
                                >
                                    <div class="snippet-content">
                                        <p class="stm">{{ testimonial.message }}</p>
                                        <div class="media">
                                            <div class="media-left">
                                                <img src="../../../assets/images/{{ testimonial.photo }}" loading="lazy" decoding="async" alt="{{ testimonial.author }} - testimonial" />
                                            </div>
                                            <div class="media-body">
                                                <span class="authorName">{{ testimonial.author }}</span>
                                                <p [innerHTML]="testimonial.designation"></p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div id="testimonial-announcer"
                                    class="sr-only"
                                    aria-live="polite"
                                    aria-atomic="true">
                                </div>
                            </div>
                        </div>
                        <a class="carousel-control-prev" href="#snippetSlider" data-slide="prev" aria-label="Previous testimonial">
                            <svg width="32px" height="32px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M15 7L10 12L15 17" stroke="#878787" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                        </a>
                        <a class="carousel-control-next" href="#snippetSlider" data-slide="next" aria-label="Next testimonial">
                            <svg width="32px" height="32px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" transform="rotate(180)"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M15 7L10 12L15 17" stroke="#878787" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd list-wrapper-style-2">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-12 col-lg-12">
                <div class="trinka-title mb-0 text-center">
                    <h2>Who Would Benefit From the <br class="d-md-block d-none"/>Trinka's Grammar Checker?</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <!-- <p class="w-70">Anyone who wants to improve their writing. Students, teachers, researchers and content writers use Trinka.</p> -->
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-6 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-none">
                    <h3>Students</h3>
                    <ul class="bt-list">
                        <li>Finish homework faster</li>
                        <li>Helps write with confidence and clarity</li>
                        <li>The end result is sure to impress professors</li>
                    </ul>
                </div>
            </div>
        
            <div class="col-lg-6 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards">
                    <h3>Researchers</h3>
                    <ul class="bt-list">
                        <li>Improve papers, journal articles, and dissertations</li>
                        <li>Advanced grammar checks</li>
                        <li>Academic style guidance</li>
                    </ul>
                </div>
            </div>
        
            <div class="col-lg-6 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-1">
                    <h3>Professionals</h3>
                    <ul class="bt-list">
                        <li>Clear, professional, and error-free communication</li>
                        <li>Write emails to client-facing presentations</li>
                        <li>Our grammar checker assists in precise editing</li>
                    </ul>
                </div>
            </div>
        
            <div class="col-lg-6 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-1">
                    <h3>Content Creators</h3>
                    <ul class="bt-list">
                        <li>Create fluent, engaging, and polished content</li>
                        <li>Improve writing style and tone</li>
                        <li>Create material that wows your audience</li>
                    </ul>
                </div>
            </div>
        
            <div class="col-12">
                <div class="btn-group justify-content-center mt-3">
                    <a href="https://cloud.trinka.ai/signup?_rg=GB" target="_blank" rel="noopener noreferrer" class="filled-btn">
                        Sign Up for Free
                    </a>
                </div>
            </div>
        </div>
    </div>
</section>


<div class="trinka-banner section-pd-sm" id="real-time">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-md-10 col-lg-10">
                <div class="trinka-title text-center">
                    <h2 class="text-white">Get Real-time Grammar Checks on Your Favorite Websites for FREE!</h2>
                </div>
                <div class="btn-group justify-content-center">
                    <a  id="GCChromeButton" href="https://chrome.google.com/webstore/detail/trinka-ai-for-chrome/bbcmnbnmngpeofmpcdlcfalbniefegbp" target="_blank" rel="noopener noreferrer" class="white-btn"><img src="../../../assets/images/NewChromeIcon.svg" loading="lazy" decoding="async" width="32" height="32" alt="chrome"> Download for Chrome</a>
                    <a  id="GCFirFoxButton" href="https://addons.mozilla.org/en-US/firefox/addon/trinka-ai-firefox-browser/" target="_blank" rel="noopener noreferrer" class="white-btn"><img src="../../../assets/images/NewFirefoxIcon.svg" loading="lazy" decoding="async"  width="32" height="32" alt="firefox "> Download for Firefox</a>
                    <a  id="GCEdgeButton" href="https://microsoftedge.microsoft.com/addons/detail/trinka-ai-for-edge/kjhkcgjfbpppkbhhaocagkmfkkiibeap" target="_blank" rel="noopener noreferrer" class="white-btn"><img src="../../../assets/images/EdgeWhite_BGAndOutline.svg" loading="lazy" decoding="async"  width="32" height="32" alt="edge"> Download for Edge</a>
                </div>
            </div>
        </div>  
    </div>
</div>


<section class="section-pd">
    <div class="trinka_container container">
        <div class="row align-items-center justify-content-center">
            <div class="col-md-6 col-lg-6">
                <div class="trinka-title mb-0">
                    <h2>Is Your Document Grammatically Correct?</h2>
                    <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                    <p class="mb-40">
                        Try Our Free Grammar Checker Now & Fix Your Entire Document in Few Minutes
                    </p>
                    <div class="btn-group">
                        <a [href]="trinkaCloudUrl + '/guest-mode?redirect=grammer&rg_GB'" class="filled-btn" id="grammerSignUpButton" target="_blank" rel="noopener noreferrer" (click)="trackGrammarCheckerClick()">
                            <span>Check Grammar Checker Now! </span>
                        </a>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-lg-6">
                <div class="text-center mt-3 mt-md-0">
                    <img src="assets/images/features/grammar-checker/Bubble-view.svg" width="495" height="406" alt="grammar checker" class="img-fluid" />
                </div>
            </div>
        </div>  
    </div>
</section>

<section class="section-pd pt-0">
    <app-power-mode-section></app-power-mode-section>
</section>


<app-get-trinka></app-get-trinka>

<!-- <section class="section-pd list-wrapper-style-2 pb-0">
    <div class="trinka_container">
        <div class="row align-items-center">
            <div class="col-md-6">
                <div class="list-wrapper-content-2 pr-40">
                    <h2>Learn Grammar with Trinka’s Grammar Checker
                    </h2>
                    <p>Our grammar checker gives you a language quality score and explains each fix. Both help you improve your writing over time. Students use Trinka to form good writing habits</p>
                </div>
            </div>
            <div class="col-md-6">
                <div class="list-wrapper-image features-img">
                    <picture>
                        <source srcset="../../../assets/images/LearnGrammarwithTrinka.webp" type="image/webp">
                        <img src="../../../assets/images/LearnGrammarwithTrinka.png" width="435" height="435" class="grammar-check-img" loading="lazy" decoding="async" alt="grammar checker">
                    </picture>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd list-wrapper-style-2 pt-0">
    <div class="trinka_container">
        <div class="row align-items-center flex-row-reverse">
            <div class="col-md-6">
                <div class="list-wrapper-content-2 pl-40">
                    <h2>Make Your Writing More Effective with Trinka’s Grammar Checker Tool</h2>
                    <p>Our grammar checker helps you improve spelling, grammar, punctuation, word choice, structure, and tone. All in one platform.
                    </p>
                </div>
            </div>
            <div class="col-md-6">
                <div class="list-wrapper-image">
                    <img src="../../../assets/images/ai-grammar-checker-tool-trinka.webp" width="435" height="435" class="grammar-check-img" loading="lazy" decoding="async" alt="AI Grammar Checker for academic writing">
                </div>
            </div>
        </div>
    </div>
</section> -->

<section class="section-pd">
    <app-tool-kit [hiddenTools]="['grammar-checker']"></app-tool-kit>
</section>

<section class="trinka-banner section-pd-sm">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-10 col-lg-8">
                <div class="trinka-title mb-0 text-center">
                    <h2 class="text-white mb-4">What Are You Waiting for?</h2>
                    <div class="btn-group justify-content-center">
                        <a href="https://cloud.trinka.ai/signup?_rg=GB" target="_blank" class="white-btn" id="grammerSignUpButton">
                            <span>Register for Free</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>  
    </div>
</section>


<div class="faqQuestionAnwser section-pd" #target>
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-lg-8 col-md-10">
                <div class="trinka-title text-center">
                    <h2>Trinka’s Grammar Checker FAQ</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="faqQuestionsList">
            <div class="accordion" id="faq">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="faqContainer">
                            <div class="card">
                                <div class="card-header" id="faq2">
                                    <h3>
                                        <button type="button" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#faq2Content" aria-expanded="false" aria-controls="faq2Content">
                                            <span>How does Trinka's AI Grammar Checker work?</span>
                                        </button>
                                    </h3>
                                </div>
                            
                                <div id="faq2Content" class="collapse" aria-labelledby="faq2" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinka's AI Grammar Checker reviews your writing and looks for grammar, spelling, punctuation, sentence structure, and word choice issues. It analyzes each sentence in context. It then suggests changes that improve clarity and readability. You can review every suggestion before accepting it.</p>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="card">
                                <div class="card-header" id="faq3">
                                    <h3>
                                        <button type="button" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#faq3Content" aria-expanded="false" aria-controls="faq3Content">
                                            <span>What types of grammar mistakes can Trinka detect?</span>
                                        </button>
                                    </h3>
                                </div>
                            
                                <div id="faq3Content" class="collapse" aria-labelledby="faq3" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinka detects many common writing mistakes. These include subject verb agreement, verb tense, articles, prepositions, punctuation, spelling, capitalization, sentence fragments, run on sentences, passive voice, and word choice. It also suggests changes that improve sentence flow and readability.</p>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="card">
                                <div class="card-header" id="faq4">
                                    <h3>
                                        <button type="button" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#faq4Content" aria-expanded="false" aria-controls="faq4Content">
                                            <span>Is Trinka's Grammar Checker free to use?</span>
                                        </button>
                                    </h3>
                                </div>
                            
                                <div id="faq4Content" class="collapse" aria-labelledby="faq4" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Yes. You can use Trinka's Grammar Checker for free to identify grammar, spelling, punctuation, and language errors. <a [routerLink]="['/pricing']" class="text-link">Premium plans</a> include additional writing suggestions and advanced editing features.</p>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="card">
                                <div class="card-header" id="faq5">
                                    <h3>
                                        <button type="button" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#faq5Content" aria-expanded="false" aria-controls="faq5Content">
                                            <span>Can Trinka check academic and technical writing?</span>
                                        </button>
                                    </h3>
                                </div>
                            
                                <div id="faq5Content" class="collapse" aria-labelledby="faq5" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Yes. Trinka is designed for academic and technical writing. It helps improve research papers, journal manuscripts, theses, dissertations, technical reports, and other professional documents. The suggestions focus on improving language quality while preserving the original meaning.</p>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="card">
                                <div class="card-header" id="faq6">
                                    <h3>
                                        <button type="button" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#faq6Content" aria-expanded="false" aria-controls="faq6Content">
                                            <span>Can Trinka check research papers and journal manuscripts?</span>
                                        </button>
                                    </h3>
                                </div>
                            
                                <div id="faq6Content" class="collapse" aria-labelledby="faq6" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Yes. Trinka reviews research papers, journal manuscripts, theses, and dissertations for grammar, spelling, punctuation, and language issues. It also suggests improvements that make academic writing clearer and easier to read before submission.</p>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="card">
                                <div class="card-header" id="faq7">
                                    <h3>
                                        <button type="button" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#faq7Content" aria-expanded="false" aria-controls="faq7Content">
                                            <span>Can Trinka help improve a bachelor's, master's, or PhD thesis?</span>
                                        </button>
                                    </h3>
                                </div>
                            
                                <div id="faq7Content" class="collapse" aria-labelledby="faq7" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Yes. Trinka helps improve the language quality of theses and dissertations. It checks grammar, spelling, punctuation, sentence structure, and writing style. It can help you prepare a more polished document before submitting it for review.</p>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="card">
                                <div class="card-header" id="faq8">
                                    <h3>
                                        <button type="button" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#faq8Content" aria-expanded="false" aria-controls="faq8Content">
                                            <span>Can Trinka Grammar Checker help me improve my writing?</span>
                                        </button>
                                    </h3>
                                </div>
                            
                                <div id="faq8Content" class="collapse" aria-labelledby="faq8" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Yes. Trinka does more than correct grammar mistakes. It suggests improvements for sentence structure, word choice, clarity, and readability. Many suggestions also include explanations, which can help you become a better writer over time.</p>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="card">
                                <div class="card-header" id="faq9">
                                    <h3>
                                        <button type="button" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#faq9Content" aria-expanded="false" aria-controls="faq9Content">
                                            <span>Can Trinka improve writing style and readability?</span>
                                        </button>
                                    </h3>
                                </div>
                            
                                <div id="faq9Content" class="collapse" aria-labelledby="faq9" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Yes. Trinka suggests changes that make your writing easier to read. It helps improve sentence flow, word choice, and tone while keeping your original message intact.</p>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="card">
                                <div class="card-header" id="faq10">
                                    <h3>
                                        <button type="button" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#faq10Content" aria-expanded="false" aria-controls="faq10Content">
                                            <span>Can this tool be used as a punctuation and spell checker?</span>
                                        </button>
                                    </h3>
                                </div>
                            
                                <div id="faq10Content" class="collapse" aria-labelledby="faq10" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Yes. Trinka checks punctuation and spelling along with grammar. It identifies common language mistakes and suggests corrections that improve the overall quality of your writing.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-6">
                        <div class="faqContainer">
                            
                            
                            <div class="card">
                                <div class="card-header" id="faq11">
                                    <h3>
                                        <button type="button" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#faq11Content" aria-expanded="false" aria-controls="faq11Content">
                                            Where can I use Trinka's Grammar Checker?
                                        </button>
                                    </h3>
                                </div>
                            
                                <div id="faq11Content" class="collapse" aria-labelledby="faq11" data-parent="#faq">
                                    <div class="card-body">
                                        <p>You can use Trinka's Grammar Checker in the Cloud Editor, Microsoft Word, <a href="https://chromewebstore.google.com/detail/trinka-ai-for-chrome/bbcmnbnmngpeofmpcdlcfalbniefegbp" class="text-link" target="_blank">Google Chrome</a>, Mozilla Firefox, <a href="https://microsoftedge.microsoft.com/addons/detail/trinka-ai-for-edge/kjhkcgjfbpppkbhhaocagkmfkkiibeap" class="text-link" target="_blank">Microsoft Edge</a>, and the <a [routerLink]="['/windows-desktop-app']" class="text-link">Windows App</a>. This allows you to review your writing across different devices and writing environments.</p>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="card">
                                <div class="card-header" id="faq12">
                                    <h3>
                                        <button type="button" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#faq12Content" aria-expanded="false" aria-controls="faq12Content">
                                            Does Trinka's Grammar Checker support both US English and UK English?
                                        </button>
                                    </h3>
                                </div>
                            
                                <div id="faq12Content" class="collapse" aria-labelledby="faq12" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Yes. Trinka supports both US English and UK English. You can choose the version that matches your writing requirements. Trinka then checks spelling, grammar, punctuation, and language based on that preference.</p>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="card">
                                <div class="card-header" id="faq13">
                                    <h3>
                                        <button type="button" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#faq13Content" aria-expanded="false" aria-controls="faq13Content">
                                            Which languages does Trinka's Grammar Checker support?
                                        </button>
                                    </h3>
                                </div>
                            
                                <div id="faq13Content" class="collapse" aria-labelledby="faq13" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinka offers language-specific Grammar Checker experiences for English, <a href="https://www.trinka.ai/jp/grammar-checker" class="text-link" target="_blank">Japanese</a>, <a href="https://trinka.enago.cn/grammar-checker" class="text-link" target="_blank">Simplified Chinese</a>, <a href="https://www.trinka.ai/tw/grammar-checker" class="text-link" target="_blank">Traditional Chinese</a>, <a href="https://www.trinka.ai/kr/grammar-checker" class="text-link" target="_blank">Korean</a>, <a href="https://www.trinka.ai/es/grammar-checker" class="text-link" target="_blank">Spanish</a>, and <a href="https://www.trinka.ai/pt/grammar-checker" class="text-link" target="_blank">Portuguese</a>, helping writers improve the quality and clarity of their content across multiple languages.</p>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="card">
                                <div class="card-header" id="faq14">
                                    <h3>
                                        <button type="button" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#faq14Content" aria-expanded="false" aria-controls="faq14Content">
                                            Are there better alternatives to Grammarly's and QuillBot Grammar Checker?
                                        </button>
                                    </h3>
                                </div>
                            
                                <div id="faq14Content" class="collapse" aria-labelledby="faq14" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Yes. Trinka grammar checker is an alternative to Grammarly and QuillBot Grammar Checker, offering AI-powered grammar checking, style improvements, paraphrasing, and writing enhancement features. Users can choose the tool that best fits their writing requirements, whether for every day, professional, or specialized content.</p>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="card">
                                <div class="card-header" id="faq15">
                                    <h3>
                                        <button type="button" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#faq15Content" aria-expanded="false" aria-controls="faq15Content">
                                            What other writing and refining tools does Trinka provide besides Grammar Checker?
                                        </button>
                                    </h3>
                                </div>
                            
                                <div id="faq15Content" class="collapse" aria-labelledby="faq15" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Besides Grammar Checker, Trinka offers AI-powered tools to improve different aspects of writing, including the <a href="/paraphrasing-tool" class="text-link">Paraphrasing Tool</a>, <a href="/journal-finder" class="text-link">Journal Finder</a>, <a href="/ai-content-detector" class="text-link">AI Detector</a>, Punctuation Checker, Spell Checker, Sentence Checker, Essay Checker, <a href="/medical-grammar-and-spelling-checker" class="text-link">Medical Grammar and Spelling Checker</a>, Academic Phrasebank, Thesis Checker, AI Editing, and Free Proofreading Tools. These tools help users enhance clarity, accuracy, style, and overall writing quality for academic, technical, and professional documents.</p>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="card">
                                <div class="card-header" id="faq16">
                                    <h3>
                                        <button type="button" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#faq16Content" aria-expanded="false" aria-controls="faq16Content">
                                            Has Trinka's Grammar Checker been evaluated for academic writing?
                                        </button>
                                    </h3>
                                </div>
                            
                                <div id="faq16Content" class="collapse" aria-labelledby="faq16" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Yes. Trinka has been evaluated for academic writing and is designed to support research papers, journal manuscripts, theses, dissertations, and other scholarly documents. It also has published evaluations that compare its performance with other grammar checking tools for academic writing.</p>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="card">
                                <div class="card-header" id="faq17">
                                    <h3>
                                        <button type="button" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#faq17Content" aria-expanded="false" aria-controls="faq17Content">
                                            What does Trinka Grammar Checker Premium plan include?
                                        </button>
                                    </h3>
                                </div>
                            
                                <div id="faq17Content" class="collapse" aria-labelledby="faq17" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinka Premium includes unlimited writing assistance, advanced grammar and paraphrasing support, AI-powered writing requests, advanced writing modes, style guide-based corrections, access to the Windows desktop app, and enhanced data privacy features. It also includes additional proofread file credits and plagiarism check credits for users who need advanced writing support.</p>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="card">
                                <div class="card-header" id="faq18">
                                    <h3>
                                        <button type="button" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#faq18Content" aria-expanded="false" aria-controls="faq18Content">
                                            Is Trinka Premium limited to Grammar Checker?
                                        </button>
                                    </h3>
                                </div>
                            
                                <div id="faq18Content" class="collapse" aria-labelledby="faq18" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinka Premium includes more than advanced grammar checking. It also offers writing style suggestions, consistency checks, publication-ready writing recommendations, citation support, and other features designed to improve academic, technical, and professional writing. Some Trinka tools and services, such as the <a href="/ai-content-detector" class="text-link">AI Detector</a>, <a href="/paraphrasing-tool" class="text-link">Paraphrasing Tool</a>, and <a href="/journal-finder" class="text-link">Journal Finder</a>, are available separately or may have their own usage limits depending on your subscription plan.</p>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="supportedLanguageModal" tabindex="-1" aria-labelledby="supportedLanguageModal" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
                <h6 class="modal-title">Supported Languages</h6>
                <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-4 col-md-4 col-sm-6 col-12">
                        <h3>Europe</h3>
                        <ul>
                            <li><b>NL</b> - Dutch</li>
                            <li><b>IT</b> - Italian</li>
                            <li><b>PL</b> - Polish</li>
                            <li><b>PT</b> - Portuguese (EU)</li>
                            <li><b>DE-AT</b> - German (Austria)</li>
                            <li><b>DE-CH</b> - German (Swiss)</li>
                            <li><b>SV</b> - Swedish</li>
                            <li><b>FR</b> - French</li>
                            <li><b>CA</b> - Catalan</li>
                            <li><b>DA</b> - Danish</li>
                            <li><b>NB</b> - Norwegian</li>
                        </ul>
                    </div>
                
                    <div class="col-lg-4 col-md-4 col-sm-6 col-12">
                        <h3>Asia &amp; Africa</h3>
                        <ul class="br-0">
                            <li><b>TH</b> - Thai</li>
                            <li><b>TR</b> - Turkish</li>
                            <li><b>AF</b> - Afrikaans</li>
                            <li><b>TL</b> - Tagalog</li>
                            <li><b>MS</b> - Bahasa Malaysia</li>
                            <li><b>ID</b> - Bahasa Indonesia</li>
                        </ul>
                    </div>
                
                    <div class="col-lg-4 col-md-4 col-sm-6 col-12">
                        <h3>Americas</h3>
                        <ul>
                            <li><b>PT-BR</b> - Portuguese (BR)</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>